export type EntityId = string | number;

export type Login = EntityId;

export abstract class Entity<T> {
  public readonly id: EntityId;
  public readonly props: T;

  protected constructor(props: T, defaultId: EntityId, id?: EntityId) {
    if ((props as unknown as IHaveId).id) {
      this.id = (props as unknown as IHaveId).id;
    } else {
      this.id = id ? id : defaultId;
    }

    this.props = props;
  }

  public static isEntity(v: unknown): v is Entity<unknown> {
    return v instanceof Entity;
  }

  public equals(object?: Entity<T>): boolean {
    if (!object) {
      return false;
    }

    if (this === object) {
      return true;
    }

    if (!Entity.isEntity(object)) {
      return false;
    }

    return this.id === object.id;
  }

  public isTransient(): boolean {
    return !this.id;
  }
}

interface IHaveId {
  id: EntityId;
}
